'use strict';
(function () {
	angular.module('onboarding.services')
		.factory('validationService', validationService);

	function validationService() {

		return {
			isValidCanadianPostalCode: isValidCanadianPostalCode,
			isValidEmail: isValidEmail,
			isValidUsPostalCode: isValidUsPostalCode,
			isValidPassword: isValidPassword
		};

		function isValidCanadianPostalCode(postalCode) {
			//Canadian postal codes can't contain the letters D, F, I, O, Q, or U, and cannot start with W or Z
			return /^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ] ?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/i.test(postalCode);
		}

		function isValidEmail(email) {
			// eslint-disable-next-line no-useless-escape
			return /^([a-zA-Z0-9])([a-zA-Z0-9_\.\-])*([a-zA-Z0-9_])\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z]{2,4})+$/.test(email);
		}

		function isValidUsPostalCode(postalCode) {
			if (/^[0-9]{5}$/.test(postalCode)) { //97008
				return true;
			} else if (/^[0-9]{5}(-[0-9]{4})$/.test(postalCode)) { //97008-4928
				return true;
			}

			return false;
		}

		function isValidPassword(password) {
			if (password.length > 0) {
				var hasLowerCase = Boolean(/^(?=.*[a-z])/.test(password));
				var hasUpperCase = Boolean(/^(?=.*[A-Z])/.test(password));
				var hasNumber = Boolean(/^(?=.*\d)/.test(password));
				var hasSpecialCharacter = Boolean(/(?=.*[\W|_])/.test(password));
				var hasThreePasswordStrengths = Number(hasLowerCase) + Number(hasUpperCase) + Number(hasNumber) + Number(hasSpecialCharacter) >= 3;

				return !(!hasThreePasswordStrengths || password.length < 15);
			} else {
				return false;
			}
		}
	}
})();
